import React, { useState } from "react";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
const TITLE = "Calculatrice Angles Triangle";
const DESCRIPTION =
  "Calculatrice Angles Triangle pour faire vos calculs mathematiques rapidement et sans erreur. Saisissez vos valeurs et obtenez un resultat immediat avec une methode simple a verifier.";
const KEYWORDS =
  "angles triangle, calculatrice angles triangle, calcul en ligne, mathematiques, pourcentage, formule, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/triangle-angles";
function TriangleAnglesCalculator() {
  const [angle1, setAngle1] = useState("");
  const [angle2, setAngle2] = useState("");
  const [result, setResult] = useState("");
  const [error, setError] = useState("");

  const handleCalculate = () => {
    try {
      const a1 = parseFloat(angle1);
      const a2 = parseFloat(angle2);
      if (isNaN(a1) || isNaN(a2)) {
        setError("Veuillez entrer des valeurs valides");
        setResult("");
        return;
      }
      if (a1 + a2 >= 180) {
        setError("La somme des deux premiers angles doit être inférieure à 180°");
        setResult("");
        return;
      }
      const a3 = 180 - a1 - a2;
      setResult(a3.toFixed(2));
      setError("");
    } catch (err) {
      setError("Erreur de calcul");
    }
  };

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: "50px" }}>
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <hr />
                <div>
                  <div className="form-group">
                    <label>Angle 1 (°):</label>
                    <input
                      type="number"
                      value={angle1}
                      onChange={(e) => setAngle1(e.target.value)}
                      className="form-control"
                    />
                  </div>
                  <div className="form-group">
                    <label>Angle 2 (°):</label>
                    <input
                      type="number"
                      value={angle2}
                      onChange={(e) => setAngle2(e.target.value)}
                      className="form-control"
                    />
                  </div>
                  <button className="btn btn-success" onClick={handleCalculate}>
                    Calculer Angle 3
                  </button>
                </div>
                <br />
                {error && (
                  <p className="p-3 mb-2 bg-warning text-dark">
                    Erreur: {error}
                  </p>
                )}
                {result && (
                  <p className="p-3 mb-2 bg-success text-white">
                    Angle 3: {result}°
                  </p>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-10">
                <div className="info-sections-container">
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Types de triangles</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Triangle rectangle : un angle de 90°.
                        Triangle aigu : tous les angles sont inférieurs à 90°.
                        Triangle obtus : un angle est supérieur à 90°.
                        Exemple : 30° + 60° + 90° = 180°.
                      </p>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>

    </div>
  );
}
export default TriangleAnglesCalculator;
